export const REGISTRATION_APPROVAL_STATUS_TEXT = {
    message: 'Registration Approval via API is {suffix}',
    id: 'oe.accountAdmin.registrationApprovalViaAPIStatus',
    description: 'Label text',
};

export const REGISTRATION_APPROVAL_NOTIFICATION_TEXT = {
    id: 'oe.accountAdmin.registrationApprovalViaAPIStatusUpdated',
    description: 'Notification text',
    defaultMessage: 'Registration Approval via API Data updated'
};

export const REGISTRATION_APPROVAL_LABEL_TEXT = {
    id: 'oe.accountAdmin.registrationApprovalViaAPI',
    defaultMessage: 'Attendee Approval Via API',
    description: 'Label text for Integration Settings row',
};

export const PASSPORT_REGISTRATION_APPROVAL_STATUS_TEXT = {
    id:'oe.accountAdmin.registrationApprovalViaAPI{suffix}',
    defaultMessage: 'Attendee Approval Via API is {suffix}.',
    description: 'Status text for Integration Settings row',
};

export const ORDER_BOOKING_STATUS_TEXT = {
    id:'oe.accountAdmin.orderBooking{suffix}',
    defaultMessage: 'Order Booking is {suffix}.',
    description: 'Label text',
};

export const COORDINATOR_DENIED_NOTIFICATIONS_STATUS_TEXT = {
    id: 'oe.accountAdmin.coordinatorDeniedNotifications',
    message: 'Coordinator denied notifications {suffix}',
    description: 'Label text',
};

export const REQUEST_ACCESS_CODE_REGISTRATION_APPROVAL_STATUS_TEXT = {
    id: 'oe.accountAdmin.requestAccessCodeRegistrationViaAPIStatus',
    message: 'Request Access Code registration via API is {suffix}',
    description: 'Label text for Request Access Code registration via API toggle',
};

export const COORDINATOR_DENIED_NOTIFICATIONS_INFO_TEXT = {
    id: 'oe.accountAdmin.coordinatorDeniedNotificationsInfo',
    defaultMessage: 'Any coordinator on the event will get a notification when an attendee is denied via our Registration Approval API',
    description: 'Info text',
};

export const REGISTRATION_APPROVAL_INFO_TEXT = {
    id: 'oe.website.registrationApprovalViaAPI.info',
    defaultMessage: "When enabled Registration Approval via API allows Passport to verify attendee eligibility by querying the client's system when an attendee is not found in OE Central. This API check overrides domain-based restrictions (blocked/approved domains) and determines event access based on the client's response. If the attendee already exists in Central, no API verification is performed.",
    description: 'Info text for Registration Approval via API toggle',
};